import { connect } from 'react-redux'
import Main from './Main'

const StreamBody = ({ memberId, streamTab }) => {
  return (
    <div>
      {streamTab === 'main' && memberId && <Main memberId={memberId} />}
    </div>
  )
}

const mapStateToProps = (state) => ({
  memberId: state.memberId,
  streamTab: state.streamTab,
})

export default connect(mapStateToProps)(StreamBody)
